import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { IncomingInboxPage } from '@/pages/crm/leads/IncomingInboxPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

const incomingSearchSchema = z.object({
	status: z.enum(['active', 'rejected']).default('active'),
	pipeline: z.string().optional(),
	chain: z.enum(['all', 'chain', 'own']).default('all'),
	// Free-text filter over lead number, title, and linked contact name.
	q: z.string().optional(),
	page: z.coerce.number().default(1),
	pageSize: z.coerce.number().default(25),
	// "Received" range, ISO instants so a filtered inbox is shareable.
	createdFrom: z.string().optional(),
	createdTo: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/crm/leads/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['leads.read.own', 'leads.read.all'], redirectTo: '/dashboard' }),
	component: IncomingInboxPage,
	validateSearch: incomingSearchSchema,
});
